import { render, staticRenderFns } from "./TenancyAddendum.vue?vue&type=template&id=a541fe1c&scoped=true&"
import script from "./TenancyAddendum.vue?vue&type=script&lang=js&"
export * from "./TenancyAddendum.vue?vue&type=script&lang=js&"
import style0 from "./TenancyAddendum.vue?vue&type=style&index=0&id=a541fe1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a541fe1c",
  null
  
)

export default component.exports